module.exports = __webpack_public_path__ + "static/media/12.e28e6b22.png";